
export default {
  name: "TimelineImage",
  props: ["indexPosition", "index", "imagePath"],
  computed: {
    element() {
      return this.indexPosition === "left"
        ? ["index", "image"]
        : ["image", "index"];
    }
  }
};
